import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export var RETRY_ATTEMPTS_LIMIT = 1;

/**
 * Facilitates a customizable retry strategy for asynchronous operations prone to transient failures.
 * It allows specifying conditions under which retries should occur, the maximum number of retries,
 * and an optional callback for each retry attempt, thereby enhancing the operation's robustness.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var retryOnError = function retryOnError(initialPromiseGetter, _ref) {
  var retryFunc = _ref.retryFunc,
    retryPredicate = _ref.retryPredicate,
    _ref$retryAttempts = _ref.retryAttempts,
    retryAttempts = _ref$retryAttempts === void 0 ? RETRY_ATTEMPTS_LIMIT : _ref$retryAttempts,
    onRetry = _ref.onRetry;
  // Eventually we might like to make max attempts configurable.
  // To do so, we'll need to support jitter & exponential back-off
  var maxAttempts = retryAttempts > RETRY_ATTEMPTS_LIMIT ? RETRY_ATTEMPTS_LIMIT : retryAttempts;
  var _execute = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getPromise) {
      var retryAttempt,
        shouldAttemptRetry,
        _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            retryAttempt = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
            _context.prev = 1;
            _context.next = 4;
            return getPromise();
          case 4:
            return _context.abrupt("return", _context.sent);
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            // If no retry predicate is passed, retry on every error
            shouldAttemptRetry = retryPredicate ? retryPredicate(_context.t0) : true;
            if (!(retryAttempt < maxAttempts && shouldAttemptRetry)) {
              _context.next = 13;
              break;
            }
            onRetry && onRetry(_context.t0, retryAttempt + 1);
            return _context.abrupt("return", _execute(retryFunc, retryAttempt + 1));
          case 13:
            throw _context.t0;
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7]]);
    }));
    return function execute(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return _execute(initialPromiseGetter);
};
export var shouldRetry = function shouldRetry(error) {
  if ('statusCode' in error && typeof error.statusCode === 'number') {
    return [502, 503, 504].includes(error.statusCode);
  }
  return false;
};
export var getRetryAttemptsForQuery = function getRetryAttemptsForQuery(request) {
  if (request.operationKind === 'query') {
    return RETRY_ATTEMPTS_LIMIT;
  }
  return 0;
};